import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Users } from "../user/Users.tsx";
import { SettingsPanel } from "./SettingsPanel.tsx";
import ICalendarFactory from "../../planning/other/calendar/ICalendarFactory.tsx";
import TimePicker from '../../TimePicker.tsx';
import { GenerateFictiveData } from "../../planning/other/calendar/GenerateFictiveData.tsx";
import { Asset, AssetTable } from "../../Asset.tsx";
import APIRequest from "../../../JS/APIRequest.ts";
import Counter from "../../Counter.tsx";
import Chart, { ChartAreaSubstract, ChartBarCompare, ChartBarLine, ChartGraph } from "../../chart/ChartGraph.tsx";
import TableSortable, { Column, Row } from "../../TableSortable.tsx";

export function Settings({ }) {
    window.onscroll = function () { scrollFunction() };

    function scrollFunction() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            document.getElementById("right-panel").style.height = "0rem";
        } else {
            document.getElementById("right-panel").style.height = "3rem";
        }
    }

    const { t } = useTranslation();
    const tabs = ['setting', 'user']; //TODO Elements
    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const getIconByTab = (tab) => {
        switch (tab) {
            case 'setting': return <svg className="w-5 h-5 text-gray-500 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 90 90">
                <path d="m82.3 32.54c-2.685 0-5.092-1.544-6.326-3.929-0.246-0.475-0.504-0.948-0.774-1.416s-0.55-0.928-0.839-1.378c-1.448-2.26-1.582-5.118-0.24-7.443 1.95-3.377 0.793-7.695-2.584-9.645l-9.353-5.4c-3.377-1.95-7.695-0.793-9.645 2.584l-2e-3 3e-3c-1.323 2.291-3.814 3.641-6.456 3.512-1.148-0.056-2.301-0.056-3.455 0-2.637 0.128-5.123-1.226-6.443-3.513l-1e-3 -2e-3c-1.95-3.377-6.268-4.534-9.645-2.584l-9.353 5.4c-3.377 1.95-4.534 6.268-2.584 9.645l1e-3 2e-3c1.32 2.286 1.25 5.116-0.179 7.336-0.625 0.971-1.202 1.97-1.727 2.992-1.209 2.353-3.624 3.835-6.27 3.835h0.636c-3.9 0-7.061 3.162-7.061 7.061v10.8c0 3.9 3.161 7.061 7.061 7.061v0c2.685 0 5.092 1.544 6.326 3.929 0.246 0.475 0.504 0.947 0.774 1.416 0.27 0.468 0.55 0.928 0.839 1.378 1.448 2.26 1.582 5.118 0.24 7.442-1.95 3.377-0.793 7.696 2.584 9.645l9.353 5.4c3.377 1.95 7.695 0.793 9.645-2.584l2e-3 -3e-3c1.323-2.291 3.814-3.641 6.456-3.512 1.148 0.056 2.301 0.057 3.455 1e-3 2.637-0.128 5.123 1.226 6.443 3.513l1e-3 2e-3c1.95 3.377 6.268 4.534 9.645 2.584l9.353-5.4c3.377-1.95 4.534-6.268 2.584-9.645l-1e-3 -2e-3c-1.32-2.286-1.25-5.116 0.179-7.336 0.625-0.971 1.201-1.97 1.727-2.992 1.209-2.353 3.624-3.835 6.27-3.835h4e-3c3.9 0 7.061-3.161 7.061-7.061v-10.801c-1e-3 -3.899-3.162-7.06-7.062-7.06zm-27.302 29.778c-9.564 5.522-21.794 2.245-27.316-7.319s-2.245-21.794 7.319-27.316 21.794-2.245 27.316 7.319c5.523 9.564 2.246 21.794-7.319 27.316z" />
            </svg>;

            case 'elements': return <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 18">
                <path d="M6.143 0H1.857A1.857 1.857 0 0 0 0 1.857v4.286C0 7.169.831 8 1.857 8h4.286A1.857 1.857 0 0 0 8 6.143V1.857A1.857 1.857 0 0 0 6.143 0Zm10 0h-4.286A1.857 1.857 0 0 0 10 1.857v4.286C10 7.169 10.831 8 11.857 8h4.286A1.857 1.857 0 0 0 18 6.143V1.857A1.857 1.857 0 0 0 16.143 0Zm-10 10H1.857A1.857 1.857 0 0 0 0 11.857v4.286C0 17.169.831 18 1.857 18h4.286A1.857 1.857 0 0 0 8 16.143v-4.286A1.857 1.857 0 0 0 6.143 10Zm10 0h-4.286A1.857 1.857 0 0 0 10 11.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 18 16.143v-4.286A1.857 1.857 0 0 0 16.143 10Z" />
            </svg>;

            case 'user': return <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                <path d="M14 2a3.963 3.963 0 0 0-1.4.267 6.439 6.439 0 0 1-1.331 6.638A4 4 0 1 0 14 2Zm1 9h-1.264A6.957 6.957 0 0 1 15 15v2a2.97 2.97 0 0 1-.184 1H19a1 1 0 0 0 1-1v-1a5.006 5.006 0 0 0-5-5ZM6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Z" />
            </svg>;
            default: return <></>;
        }
    }

    const switchSettingPage = (tab) => {
        switch (tab) {
            case 'setting': return <SettingsPanel />;
            case 'elements': return;
            case 'user': return <Users />;
            default: return <></>;
        }
    }

    const [value, setValue] = useState(0);


    let colors = [];

    for (let r = 4; r < 16; r++)
        for (let g = 4; g < 16; g++)
            for (let b = 4; b < 16; b++)
                colors.push({
                    name: parseInt(r.toString(16) + g.toString(16) + b.toString(16), 16),
                    color: '#' + r.toString(16) + g.toString(16) + b.toString(16),
                    value: r + g + b,
                })

    return (
        <div className="grid grid-cols-6">
            <aside className="left-0 top-0 h-full w-1/6 fixed">
                <div className="h-full w-full px-3 py-4 overflow-y-auto bg-gray-200 shadow">
                    <div id="right-panel" className="h-12 ease-linear duration-100 "></div>
                    <ul className="space-y-2 font-medium">
                        {tabs.map(tab => {
                            return <li>
                                <button
                                    className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100"
                                    style={{ backgroundColor: (selectedTab === tab) ? 'white' : '' }}
                                    type="button"
                                    onClick={() => setSelectedTab(tab)}>

                                    {getIconByTab(tab)}
                                    <span className="ms-3"> {t(tab)} </span>
                                </button>
                            </li>
                        })}
                    </ul>
                </div>
            </aside>



            <div className="w-full px-2 col-span-5 col-start-2">
                {switchSettingPage(selectedTab)} {/*


                {/*}

                <div className="w-full">
                    <ChartGraph
                        title='graph 8'
                        data={getData()}
                        type="custom"
                        option={{
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {
                                data: ['bar', 'error']
                            },
S
                            dataZoom: [
                                {
                                    type: 'slider',
                                    filterMode: 'none'
                                },
                                {
                                    type: 'inside',
                                    filterMode: 'none'
                                }
                            ],
                            xAxis: {},
                            yAxis: {},
                            series: [
                                {
                                    type: 'custom',
                                    renderItem: function (params, api) {
                                        if (params.context.rendered) {
                                            return;
                                        }
                                        params.context.rendered = true;
                                        let points = [];
                                        for (let i = 0; i < getData().length; i++) {
                                            points.push(api.coord(getData()[i]));
                                        }
                                        let color = api.visual('color');
                                        return {
                                            type: 'polygon',
                                            transition: ['shape'],
                                            shape: {
                                                points: points
                                            },
                                            style: api.style({
                                                fill: color,
                                                stroke: '#8f8'
                                            })
                                        };
                                    },
                                    clip: true,
                                    data: getData()
                                }
                            ]
                        }}
                    />

                </div>
                { 
                    <TimePicker
                        range={{ start: 8, end: 17 }}
                        value={{ hour: 8, minute: 17 }}
                        step={5}
                    />
                }

                <div className="text-xs grid font-mono">{GenerateFictiveData.generate(10, 50, 8).map(line => (
                    <div>{line}</div>
                ))}</div>
                {*/
                /*}

                {

                    //tpm()
                    //ICalendarFactory.testGetWeek()
                }

                    <TableSortable
                        title={'color'}
                        cols={[
                            new Column('name', 'name', 1),
                            new Column('color', 'color', 1),
                            new Column('value', 'value', 1)
                        ]}
                        rows={colors.map((hex) => (
                            new Row(
                                hex,
                                (row_element, i, col) => (
                                    <div className="flex relative">
                                        <div className="w-3 mr-2 h-full">
                                            <div className="absolute w-3 h-3 rounded top-1/2 -translate-y-1/2" style={{ backgroundColor: row_element }}></div>
                                        </div>
                                        <p>{row_element}</p>
                                    </div>
                                )
                            )
                        ))}
                    />

                {*/


                }
            </div>
        </div>
    );

}
